import snakewoman from '../assets/img/covers/snakewoman.jpg';
import garden from '../assets/img/covers/garden.jpg';
import child from '../assets/img/covers/child.jpg';
import spaceocean from '../assets/img/covers/spaceocean.jpg';
import sentinel from '../assets/img/covers/sentinel.jpg';

import clumsyforest from '../assets/img/covers/clumsyforest.jpg';
import sphericalmirrors from '../assets/img/covers/sphericalmirrors.jpg';
import incantation from '../assets/img/covers/incantation.jpg';
import threebone from '../assets/img/covers/threebone.jpg';
import armfoot from '../assets/img/covers/armfoot.jpg';
import mira from '../assets/img/covers/mira.jpg';
import broken from '../assets/img/covers/broken.jpg';
import thought from '../assets/img/covers/thought.jpg';
import christmas from '../assets/img/covers/christmas.jpg';
import tiny from '../assets/img/covers/tiny.jpg';
import liquidbody from '../assets/img/covers/liquid.jpg';

const SketchList = [
  {
    id: 1,
    cover: christmas,
    path: '../assets/img/covers/christmas.jpg',
    url: 'webgl/ritaschristmas',
    // component: SphericalMirrors,
    title: "Rita's Christmas"
  },
  {
    id: 2,
    cover: liquidbody,
    path: '../assets/img/covers/liquid.jpg',
    url: 'webgl/liquidbody',
    // component: SphericalMirrors,
    title: "Liquid Body"
  },
  {
    id: 3,
    cover: tiny,
    path: '../assets/img/covers/tiny.jpg',
    url: 'webgl/tiny',
    // component: SphericalMirrors,
    title: "Tiny"
  },
  {
    id: 4,
    cover: mira,
    path: '../assets/img/covers/spaceocean.jpg',
    url: 'webgl/mira',
    // component: Mira,
    title: 'Mira'
  },
  {
    id: 5,
    cover: threebone,
    path: '../assets/img/covers/incantation.jpg',
    url: 'webgl/threebone',
    // component: SphericalMirrors,
    title: 'ThreeBone'
  },
  {
    id: 6,
    cover: incantation,
    path: '../assets/img/covers/incantation.jpg',
    url: 'webgl/incantation',
    // component: SphericalMirrors,
    title: 'Incantation'
  },
  {
    id: 7,
    cover: armfoot,
    path: '../assets/img/covers/armfoot.jpg',
    url: 'webgl/armfoot',
    // component: SphericalMirrors,
    title: 'Arm Foot'
  },
  {
    id: 8,
    cover: thought,
    path: '../assets/img/covers/spaceocean.jpg',
    url: 'webgl/thought',
    // component: Thought,
    title: 'Thought'
  },
  {
    id: 9,
    cover: child,
    path: '../assets/img/covers/child.jpg',
    url: '/webgl/child',
    // component: Child,
    title: 'Child'
  },
  {
    id: 10,
    cover: snakewoman,
    path: '../assets/img/covers/snakewoman.jpg',
    url: 'webgl/snakewoman',
    // component: Snakewoman,
    title: 'Snakewoman'
  },
  {
    id: 11,
    cover: garden,
    path: '../assets/img/covers/garden.jpg',
    url: 'webgl/garden',
    // component: Garden,
    title: 'Garden'
  },

  {
    id: 12,
    cover: clumsyforest,
    path: '../assets/img/covers/clumsyforest.jpg',
    url: '/webgl/clumsyforest',
    // component: ClumsyForest,
    title: 'Clumsy Forest'
  },
  {
    id: 13,
    cover: sentinel,
    path: '../assets/img/covers/sentinel.jpg',
    url: '/webgl/sentinel',
    // component: Sentinel,
    title: 'Sentinel'
  },

  {
    id: 14,
    cover: spaceocean,
    path: '../assets/img/covers/spaceocean.jpg',
    url: 'webgl/spaceocean',
    // component: SpaceOcean,
    title: 'Space Ocean'
  },

  {
    id: 15,
    cover: broken,
    path: '../assets/img/covers/spaceocean.jpg',
    url: 'webgl/broken',
    // component: Broken,
    title: 'Broken'
  },
  {
    id: 16,
    cover: sphericalmirrors,
    path: '../assets/img/covers/sphericalmirrors.jpg',
    url: 'webgl/sphericalmirrors',
    // component: SphericalMirrors,
    title: 'Spherical Mirrors'
  },
  // {
  //   id: 16,
  //   cover: sphericalmirrors,
  //   path: '../assets/img/covers/sphericalmirrors.jpg',
  //   url: 'webgl/underwater',
  //   // component: SphericalMirrors,
  //   title: "Underwater"
  // },
];

export default SketchList;
